<template functional>
  <div
    :class="[data.class, data.staticClass]"
    :style="[data.style, data.staticStyle]">
    <b-alert
      variant="danger"
      show
      v-if="props.statusCode === 0">
      <p class="font-weight-bold">{{ parent.$t("errors.0") }}</p>
    </b-alert>
    <b-alert
      variant="danger"
      show
      v-else-if="props.statusCode === 401">
      <p class="font-weight-bold">{{ parent.$t("errors.401") }}</p>
      <b-button
        variant="danger"
        block
        :to="{ name: 'Login', query: { redirect: parent.$route.fullPath } }">
        {{ parent.$t("common.login") }}
      </b-button>
    </b-alert>
    <b-alert
      variant="danger"
      show
      v-else-if="props.statusCode === 403">
      <p class="font-weight-bold">{{ parent.$t("errors.403") }}</p>
    </b-alert>
    <b-alert
      variant="danger"
      show
      v-else-if="props.statusCode === 500">
      <p class="font-weight-bold">{{ parent.$t("errors.500") }}</p>
    </b-alert>
  </div>
</template>
<script>
export default {
  functional: true,

  props: {
    statusCode: {
      type: Number,
      default: undefined
    }
  }
};
</script>
